if (!customElements.get('responsive-gallery')) {
  customElements.define('responsive-gallery', class ResponsiveGallery extends HTMLElement {
    connectedCallback() {
      this.loadButton = this.querySelector('.responsive-gallery__load-more');
      this.lightbox = this.querySelector('.responsive-gallery__dialog');
      this.inquiryDialog = this.querySelector('.responsive-gallery__inquiry-dialog');
      this.loadButton?.addEventListener('click', this.loadMore);
      this.addEventListener('click', this.handleClick);
      this.lightbox?.addEventListener('click', this.handleDialogClick);
      this.inquiryDialog?.addEventListener('click', this.handleDialogClick);

      if (this.inquiryDialog?.querySelector('[data-inquiry-posted]')) {
        this.inquiryDialog.showModal();
      }
    }

    disconnectedCallback() {
      this.loadButton?.removeEventListener('click', this.loadMore);
      this.removeEventListener('click', this.handleClick);
      this.lightbox?.removeEventListener('click', this.handleDialogClick);
      this.inquiryDialog?.removeEventListener('click', this.handleDialogClick);
    }

    loadMore = () => {
      const count = Number(this.dataset.pageSize) || 4;
      const hidden = [...this.querySelectorAll('.responsive-gallery__item[hidden]')];
      hidden.slice(0, count).forEach((item) => { item.hidden = false; });
      if (hidden.length <= count) this.loadButton?.closest('.responsive-gallery__button-wrap')?.remove();
    };

    handleClick = (event) => {
      const inquiryTrigger = event.target.closest('[data-inquiry-trigger]');
      if (inquiryTrigger) {
        this.openInquiry(inquiryTrigger);
        return;
      }

      const trigger = event.target.closest('.responsive-gallery__media[data-full]');
      if (!trigger || this.dataset.lightbox !== 'true' || !this.lightbox) return;
      const image = this.lightbox.querySelector('.responsive-gallery__lightbox-image');
      const caption = this.lightbox.querySelector('.responsive-gallery__lightbox-caption');
      const itemCaption = trigger.closest('.responsive-gallery__item')?.querySelector('.responsive-gallery__caption')?.textContent.trim();
      image.src = trigger.dataset.full;
      image.alt = trigger.dataset.alt || '';
      caption.textContent = itemCaption || '';
      caption.hidden = !itemCaption;
      this.lightbox.showModal();
    };

    openInquiry = (trigger) => {
      if (!this.inquiryDialog) return;
      const itemField = this.inquiryDialog.querySelector('[data-inquiry-item-field]');
      if (itemField) itemField.value = trigger.dataset.itemLabel || '';
      this.inquiryDialog.showModal();
    };

    handleDialogClick = (event) => {
      const dialog = event.currentTarget;
      if (event.target === dialog || event.target.closest('.responsive-gallery__close')) dialog.close();
    };
  });
}
